import PersonIcon from "@mui/icons-material/PersonOutlined";
import SecurityIcon from "@mui/icons-material/SecurityOutlined";
import { Box, MenuList } from "@mui/material";
import { useMatch } from "react-router";
import { pageRoutes } from "../../../routes";
import MenuPageItem from "./MenuPageItem";
import SettingsMenuSection from "./SettingsMenuSection";

const UserSettingsMenu = () => {
  const routeMatch = useMatch(`/:client/${pageRoutes.user}/:page`);
  const page = routeMatch?.params.page;

  return (
    <Box sx={{ p: 2, width: "100%" }}>
      <SettingsMenuSection title="Profile settings">
        <MenuList>
          <MenuPageItem title="My Profile" Icon={PersonIcon} pageName="profile" currentPage={page} />
          <MenuPageItem
            title="Password & Authentication"
            Icon={SecurityIcon}
            pageName="password-auth"
            currentPage={page}
          />
        </MenuList>
      </SettingsMenuSection>
    </Box>
  );
};

export default UserSettingsMenu;
